
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

// Utils

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';



const AccordionHeader = props => {

    const {
        applicantGuid,
        isExtended,
        name,
        parentActions: {
            toggleExtension
        }
    } = props;

    return (
        <div id = 'qle-accordion-header' className ='usa-accordion__heading gi-accordion__heading'>
            <button
                id={`accordion-trigger_${applicantGuid}`}
                onClick = { () => toggleExtension(!isExtended) }
                className={`grid-row usa-accordion__button gi-accordion-trigger ${ isExtended ? 'no-border_radius' : 'border_radius' }`}
                aria-expanded="true"  aria-controls={`accordion-panel_${applicantGuid}`}
            >
                <h2 className='desktop:grid-col-10 tablet:grid-col-10 grid-col-10 margin-0 gi-accordion-trigger-title'>
                    { normalizeNameOfPerson(name) }
                </h2>
                <div className='desktop:grid-col-2 tablet:grid-col-2 grid-col-2'>
                    <span className = 'float-right'>
                        <FormattedMessage id = { isExtended ? 'common.hide' : 'common.show' } /> &nbsp;
                        <FontAwesomeIcon
                            className = 'gi-accordion-icon margin-top-1 pointer'
                            icon = { isExtended ? 'minus' : 'plus' }
                        />
                    </span>

                </div>
            </button>
        </div>
    );
};

export default AccordionHeader;